export const EVENT_CATEGORY_DIET_PLAN = 'diet plan';
export const EVENT_CATEGORY_SHOPPING_LIST = 'shopping list';
export const EVENT_CATEGORY_CONVERSION = 'conversion';
export const EVENT_CATEGORY_HYDRATION = 'hydration';
